import { Checkbox } from 'cdk-radial';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './PendingSubscriptionsTable.scss';
import { 
    selectLocation,
    removeSelectedLocation,
    selectAllLocations,
    removeAllLocations
} from '../../../../redux/connectedComponent/subscriptionManagement/cancelSubscription.slice';

const SELECT_ALL = 'Select All';
const LOCATION_LABEL_POSITION = 'after';
const CancelSubscriptionOverlayContent = ({pendingEntities}) => {

    const dispatch = useDispatch();

    const state = useSelector(state => state);
    const locationsToCancelSubscription = state.cancelSubscriptionSlice.locationsToCancelSubscription;

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    useEffect(()=>{
        setSelectedLocations(locationsToCancelSubscription);
    },[locationsToCancelSubscription]);

    useEffect(()=>{
        if(locationsToCancelSubscription.length === pendingEntities.length){
            setSelectAllChecked(true);
        }
        else {
            setSelectAllChecked(false);
        }
    },[locationsToCancelSubscription, pendingEntities]);

    const handleSelectAll = (event) => {
        let checked = event.target.checked;
        setSelectAllChecked(checked);
        if(checked) {
            dispatch(selectAllLocations(pendingEntities));
        } else {
            dispatch(removeAllLocations());
        }
    }

    const handleSelect = (event, item) => {
        let checked = event.target.checked;
        if(checked) {
            dispatch(selectLocation(item));
        } else {
            dispatch(removeSelectedLocation(item));
        }
    }

    return (
        <div>
            <div className='select-all-pending-locations'>
                <Checkbox
                    hideLabel={false}
                    indeterminate={false}
                    isDisabled={false}
                    label={SELECT_ALL}
                    labelPosition={LOCATION_LABEL_POSITION}
                    truncateLabel={false}
                    onChange={(event) => {handleSelectAll(event)}}
                    checked={selectAllChecked}
                />
            </div>
            <div className='pending-locations-overflow'>
                {
                    pendingEntities.map(item => {
                        return (
                            <div className='pending-locations' key={item.entityName}>
                                <Checkbox 
                                hideLabel={false}
                                indeterminate={false}
                                label={item.entityName}
                                labelPosition={LOCATION_LABEL_POSITION}
                                onChange={(event) => {handleSelect(event, item)}}
                                truncateLabel={false}
                                checked={selectedLocations && selectedLocations.includes(item)}
                                />
                            </div>    
                        )
                    })
                }
            </div>
        </div>
    )
}

export default CancelSubscriptionOverlayContent;